import styles from './Footer.module.css'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.section}>
            <h3 className={styles.title}>Tortu-k</h3>
            <p className={styles.description}>
              La libertad de cambiar, con la consciencia de cuidar. Carátulas magnéticas de plástico marino rescatado de Veracruz.
            </p>
          </div>

          <nav className={styles.section} aria-label="Enlaces de tienda">
            <h4 className={styles.subtitle}>Tienda</h4>
            <ul className={styles.list}>
              <li>
                <a href="#products">Productos</a>
              </li>
              <li>
                <a href="#try-on">Prueba Virtual</a>
              </li>
            </ul>
          </nav>

          <nav className={styles.section} aria-label="Nuestra Historia">
            <h4 className={styles.subtitle}>Historia</h4>
            <ul className={styles.list}>
              <li>
                <a href="#how-it-works">Cómo Funciona</a>
              </li>
              <li>
                <a href="#impact">Nuestro Impacto</a>
              </li>
            </ul>
          </nav>
        </div>

        <div className={styles.bottom}>
          <p>&copy; {currentYear} Tortu-k. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  )
}
